import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from '../router.js'


Vue.use(VueAxios, axios)

let apiList = Vue.axios.create({
  method: 'GET',
  baseURL: '/url/'
})

let apiCrfCod = Vue.axios.create({
  method: 'GET',
  baseURL: '/api/'
})
apiCrfCod.interceptors.response.use(response => {
  return response;
}, error => {
  if (error && error.response) {
    switch (error.response.status) {
      case 404: router.push({ path: '/abnormal' }); break;
      case 502: router.push({ path: '/unusual' }); break;
    }
  }
})

let apiCollection = Vue.axios.create({
  method: 'GET',
  baseURL: '/apis/'
})
let apiCollections = Vue.axios.create({
  method: 'GET',
  baseURL: ''
})
let apiSubmit = Vue.axios.create({
  method: 'POST',
  baseURL: '',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})
let apiResource = Vue.axios.create({
  method: 'POST',
  baseURL: '/api'
})
let apiUrl = Vue.axios.create({
  method: 'POST',
  baseURL: ''
})
apiResource.interceptors.response.use(response => {
  return response;
}, error => {
  if (error && error.response) {
    switch (error.response.status) {
      case 404: router.push({ path: '/abnormal' }); break;
      case 502: router.push({ path: '/unusual' }); break;
    }
  }
})

export default {
  // 验证用户会员号和密码
  login: opts => {
    const formData = new FormData();
    for (let key in opts) {
      if (opts[key]) {
        formData.append(key, opts[key]);
      }
    }
    return apiSubmit({ url: '/j_spring_security_check', params: { ...opts } })
  },
  getKey: (opts) => {
    return apiUrl({ url: '/service/rest/fw.System/collection/key', params: { ...opts } })
  },
  getVerify: () => {
    return apiUrl({
      url: '/service/rest/feishu.LsAppDownloadService/user/checkAuthority'
    })
  },
  //  验证不同机型给后台传参
  getModelVerification: opts => {
    return apiUrl({
      url: '/service/rest/feishu.LsAppDownloadService/user/download',
      params: { ...opts }
    })
  },
  // 激活接口
  getUserinformation: opts => {
    return apiUrl({
      url: '/service/rest/feishu.LsAppDownloadService/user/active',
      data: { ...opts }
    })
  },
}